export const PRODUCT_CATEGORY = Object.freeze({
  AUDIENCE: 'audience_panel',
  EXPERT_SOLUTIONS: 'expert_solutions',
});

export const FILTER_KEY = Object.freeze({
  CATEGORY: 'category',
});

export const NAV_VARIANT = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
});
